const narrowSize = 768
const largeSize = 1024
const xLargeSize = 1280

const isSmallDevice = () => {
  return window.matchMedia(`(max-width:${narrowSize - 1}px)`).matches
}

const isNarrowDevice = () => {
  return window.matchMedia(`(max-width:${largeSize - 1}px)`).matches
}

const isNarrowOnlyDevice = () => {
  return window.matchMedia(`(min-width:${narrowSize}) and (max-width:${largeSize - 1}px)`).matches
}

const isXLargeDevice = () => {
  return window.matchMedia(`(min-width:${xLargeSize}px)`).matches
}

export {
  isSmallDevice,
  isNarrowDevice,
  isNarrowOnlyDevice,
  isXLargeDevice
}



//////////////////
// WEBPACK FOOTER
// ./src/js/sb/mediaQueries.js
// module id = 1
// module chunks = 0